import { render } from "./ProductBasePricingDelivery.html?vue&type=template&id=660c5384&scoped=true"
import script from "./ProductBasePricingDelivery.js?vue&type=script&lang=js"
export * from "./ProductBasePricingDelivery.js?vue&type=script&lang=js"

import "./ProductBasePricingDelivery.css?vue&type=style&index=0&id=660c5384&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660c5384"]])

export default __exports__